import { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Space,
  InputNumber,
  Upload,
  message,
  Modal,
} from "antd";
import { getDirectusClient } from "../../../lib/directus";
import Layouts from "../../../components/Layouts";
import {
  MinusCircleOutlined,
  PlusOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { redirect, useNavigate } from "react-router-dom";
import { createItem, createItems, readItems, uploadFiles } from "@directus/sdk";
import * as pdfjs from "pdfjs-dist";
import { useSelector } from "react-redux";
import { formatPrice } from "../../../lib/utils";

const { Option } = Select;
const { Dragger } = Upload;
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();
const OrdersCreate = () => {
  const navigate = useNavigate();
  const signoMoneda = useSelector((state) => state.signoMoneda.signo_moneda);
  const [proveedores, setProveedores] = useState([]);
  const [productos, setProductos] = useState([]);
  const [estados, setEstado] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);

  const [cantidad, setCatidad] = useState(null);
  const [precio, setPrecio] = useState(null);

  const [desceunto, setDescuento] = useState(null);
  const [valosim, setValosim] = useState(null);
  const [iditem, setIditem] = useState(null);

  const [totalprice, setTotalprice] = useState(0);

  const [form] = useForm();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [fileId, setFileId] = useState(null);
  const user = useSelector((state) => state.userdata);
  // Add new state for product taxes
  const [productTaxes, setProductTaxes] = useState({});

  // Add new state variables for different totals
  const [totals, setTotals] = useState({
    subtotal: 0,
    groupTaxTotal: 0,
    iscTotal: 0,
    grandTotal: 0,
  });

  useEffect(() => {
    async function fetchProveedores() {
      const directus = await getDirectusClient();
      await directus
        .request(readItems("proveedores", { limit: -1 }))
        .then((proveedores) => {
          setProveedores(proveedores);
        });
    }

    async function fetchProductos() {
      const directus = await getDirectusClient();
      await directus
        .request(
          readItems("productos", {
            fields: [
              "id",
              "descuento_comercial",
              "nombre",
              "preciosinimp",
              "precio_base",
              "grupo.impuesto",
              "grupo.nombre",
              "estado.nombre",
              "estado.id",
              "descuentos.id",
              "descuentos.descuento",
              "descuentos.producto",
            ],
            limit: -1,
          })
        )
        .then((productos) => {
          setProductos(productos);
        });
    }

    async function fetchEstados() {
      const directus = await getDirectusClient();
      await directus
        .request(readItems("estados_ordenes_compra", { limit: -1 }))
        .then((estados) => {
          setEstado(estados);
        });
    }

    fetchProveedores();
    fetchProductos();
    fetchEstados();
  }, []);

  const onFinish = async (values) => {
    Modal.confirm({
      title: "Confirmar creación",
      content: "¿Está seguro de que desea crear esta orden de compra?",
      okText: "Sí, crear",
      cancelText: "Cancelar",
      onOk: async () => {
        const directus = await getDirectusClient();
        setLoading(true);

        try {
          // Process products to calculate unit price
          const processedProducts = values.productoss.map((product) => ({
            ...product,
            precio_uni_final: product.precio_uni_final / product.cantidad,
          }));

          console.log("processedProducts", processedProducts);

          const ordenDeCompra = {
            numero_factura: values.numero_factura,
            proveedor: values.proveedor,
            estado: 1,
            fecha: new Date().toISOString().split("T")[0],
            productos: processedProducts,
            comprobante: fileId,
            // Add new fields
            ingresado_por: user.id,
            impuesto_isc: totals.iscTotal,
            impuesto_itbms: totals.groupTaxTotal,
            precio_total: totals.grandTotal,
            subtotal: totals.subtotal,
          };

          const orden = await directus.request(
            createItems("ordenes_decompra", ordenDeCompra)
          );

          if (orden.id) {
            message.success("Orden de compra creada exitosamente");
            navigate(`/order_assign/${orden.id}`);
          }
        } catch (error) {
          console.error(error);
          message.error("Error al crear la orden de compra");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  // Add helper function to get current user

  const handleSearch = async (value) => {
    console.log("buscando");
    const directus = await getDirectusClient();
    setLoading(true);
    await directus
      .request(
        readItems("productos", {
          search: value,
          fields: "*.*",
        })
      )
      .then((response) => {
        setProductos(response);
        setLoadings(false);
      });
  };



  const handleFileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("title", file.name);
      formData.append("type", file.type);

      const directus = await getDirectusClient();
      const response = await directus.request(uploadFiles(formData));

      if (response.id) {
        setFileId(response.id);
        message.success("Archivo subido correctamente");
      }
      return false; // Prevent default upload behavior
    } catch (error) {
      console.error("Error uploading file:", error);
      message.error("Error al subir el archivo");
      return false;
    }
  };

  // Update the calculateProductTaxes function
  const calculateProductTaxes = async (productId, precioFinal, precioCompra, cantidad) => {
    if (!productId || !precioFinal) return null;

    try {
      const directus = await getDirectusClient();

      // Get product with group details
      const product = await directus.request(
        readItems("productos", {
          fields: ["id", "grupo.id", "grupo.impuesto"],
          filter: { id: { _eq: productId } },
        })
      );

      if (!product[0]?.grupo?.id) return null;

      const groupTaxPercentage = parseFloat(product[0].grupo.impuesto || 0);
      
      // Use precioCompra for ITBMS calculation when currency is CRC, but use precioFinal for additional taxes
      const baseForITBMSCalculation = signoMoneda === "₡" ? (precioCompra * cantidad) : precioFinal;
      const groupTaxAmount = baseForITBMSCalculation * (groupTaxPercentage / 100);
      const totalWithGroupTax = precioFinal + groupTaxAmount;

      // Get all taxes associated with this group
      const taxes = await directus.request(
        readItems("impuestos", {
          fields: ["id", "nombre", "porcentaje"],
          filter: {
            gropo: { grupos_id: { _eq: product[0].grupo.id } },
          },
        })
      );

      let additionalTaxes = [];
      let totalAdditionalTaxes = 0;

      // Calculate all additional taxes (excluding the main group tax) - always use precioFinal
      if (taxes && taxes.length > 0) {
        additionalTaxes = taxes.map(tax => {
          const percentage = parseFloat(tax.porcentaje || 0);
          const amount = precioFinal * (percentage / 100);
          return {
            id: tax.id,
            name: tax.nombre,
            percentage: percentage,
            amount: amount
          };
        });
        
        totalAdditionalTaxes = additionalTaxes.reduce((sum, tax) => sum + tax.amount, 0);
      }

      const finalTotal = precioFinal + groupTaxAmount + totalAdditionalTaxes;

      return {
        precioBase: precioFinal,
        precioCompra: precioCompra,
        groupTaxPercentage,
        groupTaxAmount,
        totalWithGroupTax,
        additionalTaxes,
        totalAdditionalTaxes,
        finalTotal,
      };
    } catch (error) {
      console.error("Error calculating taxes:", error);
      return null;
    }
  };

  useEffect(() => {
    if (precio === null || iditem === null) return;

    const fields = form.getFieldValue("productoss");
    if (!fields || !fields[iditem]) return;

    const precioCompra = parseFloat(precio?.target?.value || 0);
    const cantidad = parseFloat(fields[iditem].cantidad || 0);
    const valorSim = parseFloat(valosim?.target?.value || 0);
    const descuento = parseFloat(desceunto?.target?.value || 0);


    const desecuentof = descuento;
    const precioFinal1 = precioCompra + valorSim;
    const prefifdesdescuento = (precioFinal1 * desecuentof) / 100;
    const precioFinal2 = precioFinal1 - prefifdesdescuento;
    const precioFinal = precioFinal2 * cantidad;

    console.log("precio final", precioFinal);

    // Update the form field
    fields[iditem] = {
      ...fields[iditem],
      precio_uni_final: precioFinal,
    };

    // Set the updated fields back to the form
    form.setFieldsValue({
      productoss: fields,
    });

    // Calculate taxes for this product
    calculateProductTaxes(fields[iditem].producto_detalle, precioFinal, precioCompra, cantidad).then(
      (taxes) => {
        if (taxes) {
          setProductTaxes((prev) => ({
            ...prev,
            [iditem]: taxes,
          }));
        }
      }
    );
  }, [precio, desceunto, valosim, iditem, cantidad]);

  // Update the useEffect for total price calculation
  useEffect(() => {
    const fields = form.getFieldValue("productoss");
    if (!fields) return;

    const calculateTotals = async () => {
      let subtotal = 0;
      let groupTaxTotal = 0;
      let additionalTaxesTotal = 0;

      for (const field of fields) {
        if (!field?.producto_detalle || !field?.precio_uni_final) continue;

        try {
          const taxes = await calculateProductTaxes(
            field.producto_detalle,
            parseFloat(field.precio_uni_final),
            parseFloat(field.precio_compra || 0),
            parseFloat(field.cantidad || 0)
          );

          if (taxes) {
            // Special calculation for CRC currency (₡)
            if (signoMoneda === "₡") {
              // For CRC, subtotal is Final V, ITBMS is calculated on Precio #
              subtotal += taxes.precioBase; // This is the Final V
              groupTaxTotal += taxes.groupTaxAmount;
              additionalTaxesTotal += taxes.totalAdditionalTaxes;
            } else {
              // Normal calculation for other currencies
              subtotal += taxes.precioBase;
              groupTaxTotal += taxes.groupTaxAmount;
              additionalTaxesTotal += taxes.totalAdditionalTaxes;
            }
          }
        } catch (error) {
          console.error("Error calculating totals:", error);
        }
      }

      const grandTotal = subtotal + groupTaxTotal + additionalTaxesTotal;

      setTotals({
        subtotal,
        groupTaxTotal,
        iscTotal: additionalTaxesTotal, // Keep the old property name for compatibility
        grandTotal,
      });
    };

    calculateTotals();
  }, [form.getFieldValue("productoss"), signoMoneda]);

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".pdf",
    beforeUpload: handleFileUpload,
    showUploadList: true,
  };
  console.log(productTaxes);

  // Update the tax information display
  const TaxInfo = ({ taxes }) => (
    <div
      style={{
        marginLeft: 8,
        padding: "4px 8px",
        background: "#f5f5f5",
        borderRadius: "4px",
        minWidth: "200px",
      }}
    >
      <p style={{ margin: "0 0 4px" }}>
        itbms ({taxes.groupTaxPercentage}%):{" "}
        {formatPrice(taxes.groupTaxAmount, signoMoneda)}
      </p>
      <p style={{ margin: "0 0 4px" }}>
        Total + itbms: {formatPrice(taxes.totalWithGroupTax, signoMoneda)}
      </p>
      {taxes.additionalTaxes && taxes.additionalTaxes.length > 0 && (
        <>
          {taxes.additionalTaxes.map((tax, index) => (
            <p key={tax.id} style={{ margin: "0 0 4px" }}>
              {tax.name} ({tax.percentage}%):{" "}
              {formatPrice(tax.amount, signoMoneda)}
            </p>
          ))}
          <p style={{ margin: "0 0 4px", fontWeight: "bold" }}>
            Total Impuestos Adicionales: {formatPrice(taxes.totalAdditionalTaxes, signoMoneda)}
          </p>
        </>
      )}
      <p style={{ margin: 0, fontWeight: "bold" }}>
        Total Final: {formatPrice(taxes.finalTotal, signoMoneda)}
      </p>
    </div>
  );

  return (
    <Layouts>
      <div className="mb-8 bg-white rounded-lg shadow-sm">
        <Dragger
          {...uploadProps}
          accept=".pdf"
          style={{
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <p className="ant-upload-drag-icon" style={{ marginBottom: "8px" }}>
            <InboxOutlined style={{ fontSize: "24px" }} />
          </p>
          <p
            className="ant-upload-text"
            style={{ fontSize: "14px", marginBottom: "4px" }}
          >
            Haga clic o arrastre un archivo PDF aquí para extraer los datos
          </p>
          <p className="ant-upload-hint" style={{ fontSize: "12px" }}>
            Solo se admiten archivos PDF
          </p>
        </Dragger>
      </div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Factura #"
          name="numero_factura"
          rules={[{ required: true, message: "Please input your factura!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="proveedor"
          label="Proveedor"
          rules={[{ required: true }]}
        >
          <Select>
            {proveedores.map((proveedor) => (
              <Option key={proveedor.id} value={proveedor.id}>
                {proveedor.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.List name="productoss">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    display: "flex",
                    marginBottom: 8,
                  }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    name={[name, "producto_detalle"]}
                    label="Producto"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Selecciona un producto"
                      showSearch={true}
                      filterOption={false}
                      onSearch={handleSearch}
                      onChange={(value) => console.log(value)}
                      style={{ width: 200 }}
                    >
                      {productos.map((product) => (
                        <Select.Option key={product.id} value={product.id}>
                          {product.nombre}{" "}
                          <span style={{ color: "#20c77c", fontSize: 12 }}>
                            {" "}
                            {product.grupo.nombre}
                          </span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="Cantidad #"
                    initialValue={0}
                    name={[name, "cantidad"]}
                    onChange={(v) => {
                      setIditem(name);
                      setCatidad(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="Descuento %"
                    type="number"
                    initialValue={0}
                    name={[name, "descuento_comercial"]}
                    onChange={(v) => {
                      setIditem(name);
                      console.log(v);
                      setDescuento(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="Precio #"
                    type="number"
                    initialValue={0}
                    name={[name, "precio_compra"]}
                    onChange={(v) => {
                      setIditem(name);
                      console.log(v);
                      setPrecio(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="Valor Sim #"
                    type="number"
                    name={[name, "valor_sim"]}
                    initialValue={0}
                    onChange={(v) => {
                      setIditem(name);
                      setValosim(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="Final V #"
                    type="number"
                    defaulValue={0}
                    initialValue={0}
                    name={[name, "precio_uni_final"]}
                    onChange={(v) => {
                      setIditem(name);
                      //setValosim(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} disabled />
                  </Form.Item>

                  {productTaxes[name] && <TaxInfo taxes={productTaxes[name]} />}

                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  agregar producto
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        <div
          style={{
            marginTop: 16,
            padding: 16,
            background: "#f5f5f5",
            borderRadius: 8,
            width: "fit-content",
            marginLeft: "auto",
          }}
        >
          {signoMoneda === "₡" ? (
            <>
              <p style={{ margin: "0 0 8px", fontWeight: "bold" }}>
                Subtotal: {formatPrice(totals.subtotal, signoMoneda)}
              </p>
              <p style={{ margin: "0 0 8px" }}>
                Impuesto itbms: {formatPrice(totals.groupTaxTotal, signoMoneda)}
              </p>
              <p style={{ margin: "0 0 8px" }}>
                Impuestos Adicionales: {formatPrice(totals.iscTotal, signoMoneda)}
              </p>
            </>
          ) : (
            <>
              <p style={{ margin: "0 0 8px" }}>
                Subtotal: {formatPrice(totals.subtotal, signoMoneda)}
              </p>
              <p style={{ margin: "0 0 8px" }}>
                Impuesto itbms: {formatPrice(totals.groupTaxTotal, signoMoneda)}
              </p>
              <p style={{ margin: "0 0 8px" }}>
                Impuestos Adicionales: {formatPrice(totals.iscTotal, signoMoneda)}
              </p>
            </>
          )}
          <p
            style={{
              margin: 0,
              fontWeight: "bold",
              borderTop: "1px solid #d9d9d9",
              paddingTop: 8,
            }}
          >
            Total Final: {formatPrice(totals.grandTotal, signoMoneda)}
          </p>
        </div>

        <Button type="primary" htmlType="submit">
          Crear orden de compra
        </Button>
      </Form>
    </Layouts>
  );
};

export default OrdersCreate;
